import { NO_SCENE_KEY } from '../constants';

export const sceneName2Key = (sceneName: string): string => sceneName || NO_SCENE_KEY;
